"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var DeleteBucketLifecycle_1 = require("../model/DeleteBucketLifecycle");
var DeleteBucketLifecycleCommand = /** @class */ (function () {
    function DeleteBucketLifecycleCommand(input) {
        this.input = input;
        this.model = DeleteBucketLifecycle_1.DeleteBucketLifecycle;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    DeleteBucketLifecycleCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return DeleteBucketLifecycleCommand;
}());
exports.DeleteBucketLifecycleCommand = DeleteBucketLifecycleCommand;
//# sourceMappingURL=DeleteBucketLifecycleCommand.js.map